import { handleActions } from 'redux-actions';
import * as documentCardActions from '../actions/documentCard';

let initState = {
  isLoading: false,
  errorMessage: '',
};

export const documentCard = handleActions(
  {
    //  GET Document by Id
    [documentCardActions.getOrderForDocumentsById]: (state, action) => {
      return { ...state, isLoading: true };
    },
    [documentCardActions.getOrderForDocumentsByIdSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        documentTypes: payload.documentTypes,
        documentsStat: payload.documentsStat,
        data: payload.response.data,
        isLoading: false,
      };
    },
    [documentCardActions.getOrderForDocumentsByIdFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoading: false,
      };
    },
  },
  initState
);
